import LabelWithTooltip from "./label-with-tooltip";

export default LabelWithTooltip;
